module.exports = __webpack_public_path__ + "img/logo-white.bfa16a8a.svg";